export default __webpack_public_path__ + "static/media/AZ.3f8547b4.svg";